module.exports = {"430603001":"长岭街道","430603002":"云溪街道","430603101":"陆城镇","430603102":"路口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430603.json
// module id = 1861
// module chunks = 0